import { render, staticRenderFns } from "./BuildImageBlock.vue?vue&type=template&id=5b7e614b&scoped=true&"
import script from "./BuildImageBlock.vue?vue&type=script&lang=js&"
export * from "./BuildImageBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildImageBlock.vue?vue&type=style&index=0&id=5b7e614b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7e614b",
  null
  
)

export default component.exports